import { render, staticRenderFns } from "./manageAndroidTier.vue?vue&type=template&id=36ac711f&"
import script from "./manageAndroidTier.vue?vue&type=script&lang=js&"
export * from "./manageAndroidTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports